<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">

      <b-tab :title="lang.tab_Details"  :title-link-class="textColors" :title-item-class="textColors" :active="!isReturningFromImport" >
        <p>{{lang.infotext_1}}:</p>
        <ProjectDetailsComponent :lang="lang.ProjectDetails"></ProjectDetailsComponent>
        
        
      </b-tab>
      
      <b-tab :title="lang.tab_BOMs"  :title-link-class="textColors" :title-item-class="textColors" :active="isReturningFromImport">
        
        <p>{{lang.infotext_3}}:</p>
        <BomsProjectTableComponent :lang="lang.BomsTable"></BomsProjectTableComponent>


        <!-- <br><br><p>{{lang.infotext_2}}:</p>
        <VariantsComponent :lang="lang.Variants"></VariantsComponent> -->
      </b-tab>
      <b-tab v-if="appConf.status.isBasicBundle == false" :title="lang.tab_BomComparison"  :title-link-class="textColors" :title-item-class="textColors"  >
        
        <BomComparisonComponent :lang="lang.BomComparison"></BomComparisonComponent>
      </b-tab>
      <!-- <b-tab :title="lang.tab_Variants"  :title-link-class="textColors" :title-item-class="textColors" >
        <p>{{lang.infotext_2}}:</p>
        
      </b-tab> -->
      <!-- <b-tab :title="lang.tab_IPC"  :title-link-class="textColors" :title-item-class="textColors" >
        <p>{{lang.infotext_4}}:</p>
        
      </b-tab> -->

    </b-tabs>

  </div>

</template>
<script>

import { mapGetters } from 'vuex'
import ProjectDetailsComponent from '@/components/shared/ProjectDetailsComponent'
import FoldersTreeComponent from '@/components/shared/FoldersTreeComponent'
import BomsProjectTableComponent from '@/components/shared/BomsProjectTableComponent'
// import VariantsComponent from '@/components/shared/VariantsComponent'
import BomComparisonComponent from '@/components/shared/BomComparisonComponent'

export default {
  name: "Content",
  components: {
    ProjectDetailsComponent,
    FoldersTreeComponent,
    BomsProjectTableComponent,
    // VariantsComponent,
    BomComparisonComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,

    }
  },
  computed: {
    ...mapGetters({
      selectedRows: 'selectedRows',
      appConf: 'appConf',
    }),
    isReturningFromImport(){
      
      if(this.$route.query.from == "/ProjectManager/ProjectImportBom"){

        return true;

      }
      if(this.$route.query.from == "/ProjectManager/ProjectBom"){

        return true;

      }
      if (this.$route.query.from == "/ProjectManager/ProjectImportBomLst") {

        return true;

      }
      return false
    },
    isAssembly(){
      return false;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    t() {
      return this.$route.query.tabIndex;
    }

  },
  created () {


  },
  updated() {


  },
  watch: {
    tabIndex: function(newVal, oldVal){

      this.$parent.$parent.$parent.switchButtons(newVal);

      if (newVal == 0) {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
      }
      if (newVal == 1) {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
        const reloadObj = {
          status: true,
          name: "BomComparisonComponent"
        }
        this.$store.dispatch("reloadAfterAction", reloadObj);
      }
      if (newVal == 2) {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_removeCheckboxVariant");
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedPartBomRow");
        const reloadObj = {
          status: true,
          name: "BomsProjectTableComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      }
    },
  }
}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails/Middle/Content/Content.vue